define('modules/uv-shared-module/InformationAction',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var InformationAction = /** @class */ (function () {
        function InformationAction() {
        }
        return InformationAction;
    }());
    exports.InformationAction = InformationAction;
});
//# sourceMappingURL=InformationAction.js.map
